<template>
  <transition name="modal">
    <div
      v-if="!!component"
      tabindex="0"
      class="fixed z-40 flex items-center justify-center w-full h-full top-0 left-0"
      @keydown.esc="hideModal"
    >
      <div class="z-50 w-3/4 mx-auto bg-white rounded">
        <div
          class="bg-indigo-700 text-white flex items-center justify-between p-4 border-b"
        >
          <h5 class="text-xl">
            {{ title }}
          </h5>
          <button class="hover:text-gray-600">
            <i class="fas fa-times" @click="hideModal"></i>
          </button>
        </div>
        <div class="p-6">
          <component
            :is="component"
            @hide="hideModal"
            v-bind="props"
          ></component>
        </div>
      </div>
      <div
        class="z-40 fixed w-full h-full top-0 left-0 bg-indigo-900 opacity-25"
        @click="hideModal"
      ></div>
      <div
        class="z-40 fixed w-full h-full top-0 left-0 bg-black opacity-25"
        @click="hideModal"
      ></div>
    </div>
  </transition>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    ...mapState({
      component: "modalComponent",
      title: "modalTitle",
      props: "modalProps",
    }),
  },
  methods: {
    ...mapMutations(["hideModal"]),
  },
};
</script>
